export const Letter = ({ ...props }) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.5 15C2.5 10.286 2.5 7.92893 3.96447 6.46447C5.42893 5 7.78595 5 12.5 5H17.5C22.214 5 24.5711 5 26.0355 6.46447C27.5 7.92893 27.5 10.286 27.5 15C27.5 19.714 27.5 22.0711 26.0355 23.5355C24.5711 25 22.214 25 17.5 25H12.5C7.78595 25 5.42893 25 3.96447 23.5355C2.5 22.0711 2.5 19.714 2.5 15Z"
        stroke="#2164FF"
        strokeWidth="2"
      />
      <path
        d="M7.5 10L10.1986 12.2489C12.4944 14.162 13.6423 15.1186 15 15.1186C16.3577 15.1186 17.5056 14.162 19.8014 12.2488L22.5 10"
        stroke="#2164FF"
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};
